import { render, staticRenderFns } from "./lowThreshold-editor.vue?vue&type=template&id=1643e664&scoped=true"
import script from "./lowThreshold-editor.vue?vue&type=script&lang=js"
export * from "./lowThreshold-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1643e664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1643e664')) {
      api.createRecord('1643e664', component.options)
    } else {
      api.reload('1643e664', component.options)
    }
    module.hot.accept("./lowThreshold-editor.vue?vue&type=template&id=1643e664&scoped=true", function () {
      api.rerender('1643e664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-rate/lowThreshold-editor.vue"
export default component.exports